import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

export async function createNewPermission(request) {
  const { code, description, application } = request
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  headers['App-Name'] = application
  const httpClient = new HttpClient(headers)
  const userInstance = httpClient.userInstance()
  const permissions = [{ name: code, description }]
  return userInstance.post('/permission', { permissions })
}

export async function updateAPermission(request) {
  const { code, description, application } = request
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  headers['App-Name'] = application
  const httpClient = new HttpClient(headers)
  const userInstance = httpClient.userInstance()
  const permission = { permissionName: code, permissionDescription: description }
  return userInstance.put('/permission', permission)
}

export async function deleteAPermission(request) {
  const { permission, application } = request
  const idToken = sessionStorage.getItem(sessionStorageKeyConstants.ID_TOKEN)
  const headers = getHeaders(idToken)
  headers['App-Name'] = application
  const httpClient = new HttpClient(headers)
  const userInstance = httpClient.userInstance()
  return userInstance.delete('/permission', { data: permission })
}
